import { gql } from '@techstyle/react-graphql';

const PRICING_FIELDS = `pricing(retailDiscounting: true) {
  final
  finalDetails {
    displayOnPdp
    promoCode
    promoLabel
    promoPrice
    promoTypeId
    __typename
  }
  masterProductId
  sales
  vip
  retail
  __typename
}`;

const PRODUCT_PRICING_LISTING_FRAGMENT = `
productListing(
    from: $from
    productQuery: $productQuery
    size: $size
    sort: $sort
  ) {
    products {
      label
      masterProductId
      ${PRICING_FIELDS}
      __typename
    }
    size
    total {
      relation
      value
      __typename
    }
    from
    __typename
  }`;

export const BASE_PRODUCTS_PRICING_QUERY = gql`
  query ProductListing(
    $productQuery: ProductQuery
    $size: Int
    $sort: Sort
    $from: Int
  ) {
    ${PRODUCT_PRICING_LISTING_FRAGMENT}
  }
`;
